import { httpClient } from "@/lib/http-client";
import sessionService from "@/lib/services/session";
import { webStorageUtil } from "@/lib/storage/webStorageUtil";
import { ELocalStorageKeys } from "@/lib/storage/enums";
import { ROUTES } from "@/lib/consts/routes";

export const clearClientSession = (): void => {
    webStorageUtil.remove(ELocalStorageKeys.SESSION_TOKEN);
    webStorageUtil.remove(ELocalStorageKeys.PLAYER_DATA);
    sessionService.clear();
    httpClient.removeDefaultHeader('Authorization');
};

export const clearSessionCookie = (): Promise<void> => {
    return fetch(ROUTES.CLEAR_SESSION, { method: 'POST', credentials: 'same-origin', keepalive: true })
        .then(() => undefined)
        .catch(() => undefined);
};

export const revokeExistingSession = async (): Promise<void> => {
    clearClientSession();
    await clearSessionCookie();
};
